import { render, staticRenderFns } from "./SpaceGroupActions.vue?vue&type=template&id=f083b6b2&"
import script from "./SpaceGroupActions.vue?vue&type=script&lang=js&"
export * from "./SpaceGroupActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports